import {store} from '~/stores'

/** 根据 h_app 返回原生 scheme：dokimo 用 dokimo，否则用 pengpeng */
export function getAppScheme() {
  const h_app = store.getState().deviceInfo?.h_app
  return h_app === 'dokimo' ? 'dokimo' : 'pengpeng'
}

/**
 * 拼接原生跳转路由
 * @param path 不含 scheme，如 `consume` 或 `webpage?url=...`；也可传入带 scheme 的完整路由
 */
export function getAppRouter(path: string) {
  if (!path) return path
  const normalized = path.replace(/^(pengpeng|dokimo):\/\//, '')
  return `${getAppScheme()}://${normalized}`
}
